<script lang="ts" setup>
  import { type PropType } from 'vue';
  import type { SaleOfferMessage } from '@storefront/storefront';
  import { type FormContextInterface, useHttpClient, setModelWithContext, useRoute } from '@othercommerce/foundation';

  const props = defineProps({
    offer: { type: Object, required: true },
    messages: { type: Object as PropType<SaleOfferMessage[]>, required: true },
  });

  const route = useRoute();
  const http = useHttpClient();

  function actionClear(ctx: FormContextInterface) {
    setModelWithContext('message', ctx, null);
  }

  function handleSubmit(data: any, ctx: FormContextInterface) {
    return http.post(route('web.account.offers.messages.store', { offer: props.offer.id }), data).then(() => {
      actionClear(ctx);
    });
  }
</script>
<template>
  <section class="chat">
    <SfTile>
      <h2 class="chat__heading">
        {{ $t('SHOP.COMMON.HEADER.CHAT') }}
      </h2>
      <FormController v-slot="{  processing, submit }" @submit="handleSubmit">
        <div class="chat__form">
          <div class="chat__control">
            <SfFormTextarea :label="$t('SHOP.COMMON.LABEL.CHAT_MESSAGE')" name="message" rows="1" />
          </div>
          <div class="chat__submit">
            <SfButton :loading="processing" primary type="submit" @click="submit">
              <template #default>
                {{ $t('SHOP.COMMON.ACTION.SEND') }}
              </template>
              <template #after>
                <SfIconSend aria-hidden="true" />
              </template>
            </SfButton>
          </div>
        </div>
      </FormController>
      <div class="chat__messages">
        <OfferChatMessage v-for="message in messages" :message="message" />
      </div>
    </SfTile>
  </section>
</template>
<style lang="scss" scoped>
  @use "@storefront/styles/mixins/media";

  .chat {
    flex-grow: 0;
    width: 100%;

    :deep(textarea) {
      &.control {
        min-height: 3rem;
      }
    }

    &__heading {
      font-size: 1.25rem;
    }

    &__form {
      display: flex;
      align-items: flex-start;
      gap: 1rem;
      width: 100%;
    }

    &__control {
      width: 100%;

      @include media.query(sm) {
        gap: 0.5rem;
      }
    }

    &__messages {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      @include media.query(md) {
        gap: 0.5rem;
      }
    }
  }
</style>
